import { Theme, alpha, useTheme } from '@mui/material';
import type { SxProps } from '@mui/system';
import { FC, ReactNode } from 'react';

import { styleConfigs } from '../../../../../../resources/styleConfigs';
import IconButtonWrapper from '../../../../../../wrappers/IconButtonWrapper';

interface IHeaderButtonProps {
  'aria-label': string;
  dataTestId: string;
  onClick: VoidFunction;
  children: ReactNode;
  alignSelf?: string;
  marginBlock?: string | number;
  marginInlineStart?: string | number;
  sx?: SxProps<Theme>;
}

const HeaderButton: FC<IHeaderButtonProps> = (props) => {
  const {
    'aria-label': ariaLabel,
    dataTestId,
    onClick,
    children,
    alignSelf = 'start',
    marginBlock = styleConfigs.marginPadding.custom1rem,
    marginInlineStart,
    sx,
  } = props;
  const theme = useTheme();

  return (
    <IconButtonWrapper
      aria-label={ariaLabel}
      data-testid={dataTestId}
      data-cy-button-type={dataTestId}
      sx={{
        alignSelf,
        marginBlock,
        marginInlineStart,
        padding: styleConfigs.marginPadding.custom2rem,
        ':hover': {
          background: alpha(theme.palette.icons.ebonyClay, 0.1),
        },
        [theme.breakpoints.down('md')]: {
          marginBlock: styleConfigs.marginPadding.empty,
          padding: styleConfigs.marginPadding.custom3rem,
        },
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </IconButtonWrapper>
  );
};

export default HeaderButton;
